import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  HostListener,
  ViewChild,
  ElementRef,
  AfterViewInit, Renderer2,
} from '@angular/core';
import {ApiService} from '../../shared/services/api.service';
import {InternalService} from '../../shared/services/internal.service';
import {NgbCarousel, NgbCarouselConfig, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {MatTabGroup} from '@angular/material/tabs';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.css'],
  providers: [NgbCarouselConfig],
})
export class HomeComponent implements OnInit, AfterViewInit {
  imageObject = [{
    image: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/5.jpg',
    thumbImage: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/5.jpg',
    title: 'Hummingbirds are amazing creatures'
}, {
    image: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/9.jpg',
    thumbImage: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/9.jpg'
}, {
    image: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/4.jpg',
    thumbImage: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/4.jpg',
    title: 'Example with title.'
},{
    image: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/7.jpg',
    thumbImage: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/7.jpg',
    title: 'Hummingbirds are amazing creatures'
}, {
    image: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/1.jpg',
    thumbImage: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/1.jpg'
}, {
    image: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/2.jpg',
    thumbImage: 'https://sanjayv.github.io/ng-image-slider/contents/assets/img/slider/2.jpg',
    title: 'Example two with title.'
}];
  // bannerImages = [
  //   '../../../assets/img/banner/1024.jpeg',
  //   '../../../assets/img/banner/1025.jpg',
  //   '../../../assets/img/banner/640.jpg',
  //   '../../../assets/img/banner/641.jpeg',
  //   '../../../assets/img/banner/1.jpg',
  // ];
  bannerImages = [
    {
      src: '../../../assets/img/banner/1024.jpeg',
      alt: {
        0:'مکانیک یکی از شغل‌های فنی و حرفه‌ای الوبدو است که در زمینه تعمیر، نگهداری و تعویض اجزای خودروها و ماشین آلات کاربرد دارد. مکانیک‌ها برای انجام کار خود از ابزارهای دقیق و ماشین آلات خاص استفاده می‌کنند و معمولاً در کارگاه‌ها و گاراژها مشغول به کار هستند. در این تصویر یک مکانیک با ابزار آلات خود ایستاده است.',
        1:'Mechanic is one of the technical and professional jobs in Alobodo, which is used in the field of repairing, maintaining, and replacing parts of cars and machinery. Mechanics use precise tools and special machines to do their work and are usually employed in workshops and garages. In this picture, a mechanic is standing with his tools and equipment.'
      }
    },
    {
      src: '../../../assets/img/banner/1025.jpg',
      alt: {
        0: 'شغل نقشه کش ساختمان یکی از حرفه‌های مرتبط با طراحی و ساخت ساختمان‌ها در الوبدو است. نقشه کشان ساختمان مسئول طراحی و نقشه کشی مدارک مورد نیاز برای ساخت ساختمان‌ها و سازه‌های دیگر می‌باشند. آنها با استفاده از نرم‌افزارهای رایانه‌ای و ابزارهای دقیق، طرح‌های فنی و اجرایی مربوط به ساختمان را به اندازه‌های دقیق می‌کشند. در این تصویر یک نقشه کش ساختمان با نقشه آماده خود ایستاده است.',
        1: 'Building drafter is one of the professions related to design and construction of buildings in Alobodo. Building drafters are responsible for designing and drafting the necessary documentation for constructing buildings and other structures. They use computer software and precise tools to draw technical and executive designs related to the building accurately. In this picture, a building drafter is standing with his prepared blueprint'
      }
    },
    {
      src: '../../../assets/img/banner/640.jpg',
      alt: {
        0: 'پزشکی یکی از شاخه‌های پایه و اساسی علوم پزشکی در الوبدو است که به بررسی، تشخیص، پیشگیری و درمان بیماری‌ها و اختلالات سلامتی انسان می‌پردازد. پزشکان برای تشخیص بیماری‌ها و درمان آن‌ها از تکنیک‌های مختلفی استفاده می‌کنند، از جمله بررسی علائم بالینی بیماری، آزمایشات تشخیصی مانند آزمایش خون و تصویربرداری، ویزیت و مشاهده بیماری‌ها در سیستم بدنی، و درمان با دارو و یا اجرای عمل جراحی در بعضی از موارد. در این پزشک خانوم ایستاده است.',
        1: 'Medicine is one of the fundamental branches of medical science in Alobodo, which deals with the examination, diagnosis, prevention, and treatment of diseases and human health disorders. Doctors use various techniques to diagnose and treat diseases, including examining clinical symptoms, diagnostic tests such as blood tests and imaging, visiting and observing diseases in the body system, and treating with medication or performing surgery in some cases. In this picture, a female doctor is standing.'
      }
    },
    {
      src: '../../../assets/img/banner/641.jpeg',
      alt: {
        0: 'تعمیرکار تلویزیون یکی از حرفه‌های فنی و حرفه‌ای در الوبدو است که در زمینه تعمیر و نگهداری تلویزیون‌های مختلف فعالیت می‌کند. این حرفه‌ای معمولاً به صورت فروشگاه‌های تعمیر و خدمات تعمیر تلویزیون و یا به عنوان تعمیرکار حرفه‌ای در سایر صنایع، مانند صنعت تلویزیون یا خدمات رسانی تلویزیونی، کار می‌کند. تعمیرکاران تلویزیون برای تشخیص مشکلات و انجام تعمیرات از ابزارهای دقیق و دانش فنی مختلف استفاده می‌کنند.',
        1: 'TV repairman is one of the technical and professional jobs in Alobodo that works in the field of repairing and maintaining various TVs. This profession usually works as a repair shop or TV repair service, or as a professional repairman in other industries such as the TV industry or TV service. TV repairmen use various technical knowledge and precise tools to diagnose problems and perform repairs.'
      }
    },
    {
      src: '../../../assets/img/banner/1.jpg',
      alt: {
        0: 'تخصص‌های مختلفی در شغل تاسیساتی الوبدو وجود دارد، از جمله مهندسین برق، مهندسین مکانیک، مهندسین تاسیسات، نصابان برق، لوله‌کش‌ها، نصابان گرمایش و سرمایش و سایر کارکنان متخصص. هدف اصلی این حرفه، ایجاد سیستم‌های تاسیساتی ایمن و موثر است که به کاهش هزینه‌ها و بهبود کارایی ساختمان‌ها و سازه‌های دیگر کمک می‌کند.',
        1: 'There are various specializations in the field of installation profession in Alobodo, including electrical engineers, mechanical engineers, installation engineers, electrical installers, pipe fitters, heating and cooling installers, and other specialized workers. The main goal of this profession is to create safe and effective installation systems that help reduce costs and improve the efficiency of buildings and other structures.'
      }
    }   
    
  ];
  images = [700, 533, 807, 124].map(
    (n) => `https://picsum.photos/id/${n}/900/500`
  );

  @ViewChild('myCarousel') myCarousel: NgbCarousel;
  tabIndex: any = 0;
  @ViewChild('mat', {static: false}) mat: MatTabGroup;
  categories: any = [];
  searchText: any = '';
  searchResult: any = [];
  popularCategories: any = [];
  // @ViewChild('searchBox') searchBox: ElementRef;
  // @ViewChild('searchInput') searchInput: ElementRef;
  loader: any = true;
  test: any;
  submitRequestLink: any = '';
  isLeaf: boolean ;

  constructor(
    public apiService: ApiService,
    private renderer: Renderer2,
    private router: Router,
    private ngbModal: NgbModal,
    public internalService: InternalService,
    public translate: TranslateService,
    config: NgbCarouselConfig
  ) {
    // config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;
    config.interval = 0;
    config.showNavigationIndicators = false;

    setInterval(() => {
      this.randomlySelectImage();
    }, 8 * 1000);

    // this.renderer.listen('window', 'click', (e: Event) => { // close search result box on click outside of box
    //   if (e.target !== this.searchBox.nativeElement && e.target !== this.searchInput.nativeElement) {
    //     document.getElementById('searchBox').style.display = 'none';
    //   }
    // });
  }

  @HostListener('window:scroll', ['$event'])
  checkOffsetTop() {
    // console.log(window.pageYOffset); // this will console log our scroll position
  }

  ngAfterViewInit() {
    // console.log(this.myCarousel);
    // this.onSlideClicked(this.myCarousel);
  }

  ngOnInit() {
    this.randomlySelectImage();
    this.getSiteCategories();
    this.getPopularCategories();

    this.submitRequestLink = `https://web.alobodo.com/services?id=` + this.popularCategories.categoryId + `&title=` + this.popularCategories.categoryName +  `&isLeaf=`+ String(this.isLeaf);
  }

  open(content) {
    this.ngbModal.open(content, {size: 'm', windowClass: 'custom-class', centered: true})
    // this.ngbModal.open(content, { centered: true });
  }

  getSiteCategories() {
    
    this.apiService.getSiteCategories().subscribe((res: any) => {
      // console.log('********',res);
      
      this.categories = res.res;
      this.categories.push({title: this.translate.instant('More')});

      for (let item of this.categories) {
        if (item.icon) {
          this.internalService.getMd5(item.icon).then((result) => {
            item.iconImage = result;
          });
        }
        if (item.banner) {
          this.internalService.getMd5(item.banner).then((result) => {
            item.bannerImage = result;
          });
        }
        if (item.subCategoies) {
          for (let subcat of item.subCategoies) {
            if (subcat.image) {
              this.internalService.getMd5(subcat.image).then((result) => {
                subcat.base64 = result;
              });
            }
          }
        }
      }
      this.loader=false;
    });
  }

/**  
* get data for popular category section 
*/  

  getPopularCategories() {
    this.apiService.getPopularCategories().subscribe((res: any) => {
      // console.log('-*/',res)
      this.popularCategories = res.res;
      for (let item of this.popularCategories) {
        this.internalService.getMd5(item.image).then((result) => {
          item.imageBase64 = result;
        });
      }
    })
  }

  randomlySelectImage() {
    const img = document.getElementById('bannerImage') as HTMLImageElement;
    // img.src = this.bannerImages[Math.floor(Math.random() * 5)].src;
      const i = Math.floor(Math.random() * 5);
      img.src = this.bannerImages[i].src;
      if (this.apiService.currentDirection == 'rtl'){
        img.alt = this.bannerImages[i].alt[0];
      } else {
        img.alt = this.bannerImages[i].alt[1];
      }
      
  }

  // test() {
  //   this.router.navigate(['https://www.medis.land']);
  //   // alert('ffffffffffff');
  // }

  onSlideClicked(myCarousel: NgbCarousel) {
    const prev = document.getElementsByClassName(
      'carousel-control-prev'
    ) as HTMLCollectionOf<Element>;
    const next = document.getElementsByClassName(
      'carousel-control-next'
    ) as HTMLCollectionOf<Element>;
    if (myCarousel.activeId === 'ngb-slide-0') {
      prev[0].setAttribute('style', 'visibility: hidden');
    } else {
      prev[0].setAttribute('style', 'visibility: visible');
    }
    if (myCarousel.activeId === `ngb-slide-${this.images.length - 1}`) {
      next[0].setAttribute('style', 'visibility: hidden');
    } else {
      next[0].setAttribute('style', 'visibility: visible');
    }
  }

  tabChange(index: number, event) {
    if (index === this.categories.length - 1) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/services/0`])
      );
      this.mat.selectedIndex = 0;
      window.open(url, '_self');
    }
  }

  // search() {
  //   // if (!this.searchText) {
  //   //   document.getElementById('searchBox').style.display = 'none';
  //   //   return false;
  //   // }
  //   localStorage.setItem('isLeaf', 'true');
  //   if (this.isEmptyOrSpaces(this.searchText)) {
  //     document.getElementById('searchBox').style.display = 'none';
  //     return false;
  //   }
  //
  //
  //   const body = {
  //     search: this.searchText
  //   };
  //
  //   this.apiService.search(body).subscribe((res: any) => {
  //     this.searchResult = res.res;
  //     // console.log(this.searchResult);
  //     if (this.searchResult.length > 0) {
  //       this.generateSearchResultItems();
  //     } else {
  //       this.clearSearchResult();
  //       const result = document.getElementById('resultResult');
  //       const li = document.createElement('li');
  //       li.innerHTML = this.translate.instant('NoResultToShow');
  //       result.append(li);
  //       document.getElementById('searchBox').style.display = 'block';
  //     }
  //
  //   });
  // }
  //
  // generateSearchResultItems() {
  //   this.clearSearchResult();
  //   const result = document.getElementById('resultResult');
  //   for (let item of this.searchResult) {
  //     const li = document.createElement('li');
  //     // li.innerHTML = `<a href="/service-description/${item.categoryId}/${item.name.replace(/\s/g, '-')}">${item.name}</a>`;
  //     li.innerHTML = `<a href="/service-description/${item.categoryId}">${item.name}</a>`;
  //     result.append(li);
  //   }
  //   document.getElementById('searchBox').style.display = 'block';
  // }
  //
  // clearSearchResult() {
  //   document.getElementById('resultResult').innerHTML = '';
  //   // document.getElementById('searchBox').style.display = 'none';
  // }
  //
  // isEmptyOrSpaces(str) {
  //   return str === null || str.match(/^ *$/) !== null;
  // }
  //
  // navigateToFirstItem() {
  //   if (this.searchResult.length > 0) {
  //     // this.router.navigate(['/service-description/' + this.searchResult[0].categoryId + '/' + this.searchResult[0].name.replace(/\s/g, '-')]);
  //     this.router.navigate(['/service-description/' + this.searchResult[0].categoryId]);
  //   }
  // }
}
